export default "__VITE_ASSET__BowFigAn__"